import RHSecretWrapUnWrap from "./RHSecretWrapUnwrap";

export default function ToolsPage() {
  return (
    <>
      <RHSecretWrapUnWrap />
    </>
  );
}
